import script from "./vmsMainGrid.vue?vue&type=script&lang=js"
export * from "./vmsMainGrid.vue?vue&type=script&lang=js"

import "./vmsMainGrid.vue?vue&type=style&index=0&id=046bdc35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046bdc35"]])

export default __exports__